import { render, staticRenderFns } from "./FormSubmit.vue?vue&type=template&id=66762d4b"
import script from "./FormSubmit.vue?vue&type=script&lang=js"
export * from "./FormSubmit.vue?vue&type=script&lang=js"
import style0 from "./FormSubmit.vue?vue&type=style&index=0&id=66762d4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports